// extracted by mini-css-extract-plugin
export default {"event-header-container":"g__event-header-container--RAUzj","event-subtitle":"g__event-subtitle--QzJYb","event-title":"g__event-title--jHkps"};